export default __webpack_public_path__ + "static/media/about-background.7f32a848.svg";